const PREFIX = "CAMPAIGN";

export class CREATE_CAMPAIGN {
  public static readonly type = `[${PREFIX}] CREATE CAMPAIGN`;
  constructor(public readonly payload) {}
}
export class PREVIEW_CAMPAIGN {
  public static readonly type = `[${PREFIX}] PREVIEW CAMPAIGN`;
  constructor(public readonly payload) {}
}
export class CHANGE_PREVIEW_CAMPAIGN {
  public static readonly type = `[${PREFIX}] CHANGE PREVIEW CAMPAIGN`;
  constructor(public readonly payload) {}
}
export class UPDATE_CAMPAIGN {
  public static readonly type = `[${PREFIX}] UPDATE CAMPAIGN`;
  constructor(public readonly payload) {}
}

export class EDIT_CAMPAIGN {
  public static readonly type = `[${PREFIX}] EDIT CAMPAIGN`;
  constructor(public readonly payload) {}
}
export class GET_CAMPAIGN {
  public static readonly type = `[${PREFIX}] GET CAMPAIGN LIST`;
  constructor(public readonly payload) {}
}

export class UPLOAD_EXCEL_FILE {
  public static readonly type = `[${PREFIX}] UPLOAD EXCEL FILE`;
  constructor(public readonly payload) {}
}

export class SET_CAMPAIGN_DETAILS {
  public static readonly type = `[${PREFIX}] SET CAMPAIGN DETAILS`;
  constructor(public readonly payload) {}
}

export class GET_CURRENT_CAMPAIGN {
  public static readonly type = `[${PREFIX}] GET CURRENT CAMPAIGN`;
  constructor(public readonly payload) {}
}

export class SET_CAMPAIGN_ARCHIVED {
  public static readonly type = `[${PREFIX}] SET CAMPAIGN ARCHIVED`;
  constructor(public readonly payload) {}
}

export class GET_BDM_AGENT_LIST {
  public static readonly type = `[${PREFIX}] GET BDM AGENT LIST`;
  constructor(public readonly payload) {}
}

export class GET_PAST_CAMPAIGN {
  public static readonly type = `[${PREFIX}] GET PAST CAMPAIGN`;
  constructor(public readonly payload) {}
}

export class GET_BRANCH_LIST {
  public static readonly type = `[${PREFIX} GET BRANCH LISTING]`;
  constructor(public readonly payload) {}
}

export class GET_CATEGORY_LOV {
  public static readonly type = `[${PREFIX}] GET CATEGORY LOV`;
}

export class GET_EXCEL_DOWNLOAD {
  public static readonly type = `[${PREFIX}] GET EXCEL DOWNLOAD`;
  constructor(public readonly payload) {}
}

export class GET_BRANCH_AGENT_LIST {
  public static readonly type = `[${PREFIX} GET BRANCH AGENT LIST]`;
  constructor(public readonly payload) {}
}

export class GET_UNTAGGED_AGENTS_LIST {
  public static readonly type = `[${PREFIX}] GET UNTAGGED AGENT LIST`;
}

export class VALIDATE_CAMPAIGN_RANK {
  public static readonly type = `[${PREFIX}] VALIDATE CAMPAIGN RANK`;
  constructor(public readonly payload) {}
}

export class CREATE_CLUB_CAMPAIGN {
  public static readonly type = `[${PREFIX}] CREATE CLUB CAMPAIGN`;
  constructor(public readonly payload) {}
}

export class UPDATE_CLUB_CAMPAIGN {
  public static readonly type = `[${PREFIX}] UPDATE CLUB CAMPAIGN`;
  constructor(public readonly payload) {}
}

export class EDIT_CLUB_CAMPAIGN {
  public static readonly type = `[${PREFIX}] EDIT CLUB CAMPAIGN`;
  constructor(public readonly payload) {}
}

export class GET_CLUB_CAMPAIGN {
  public static readonly type = `[${PREFIX}] GET CLUB CAMPAIGN`;
  constructor(public readonly payload) {}
}

export class RESET_CAMPAIGN {
  public static readonly type = `[${PREFIX}] RESET CAMPAIGN`;
}

export class GET_AGENTS_SUMMARY_LIST {
  public static readonly type = `[${PREFIX}] GET AGENTS SUMMARY LIST`;
}

export class RETRIEVE_AGENTS_LIST {
  public static readonly type = `[${PREFIX}] RETRIEVE AGENTS LIST`;
  constructor(public readonly payload) {}
}

export class SAVE_AGENT_TAGGING {
  public static readonly type = `[${PREFIX}] SAVE AGENT TAGGING`;
  constructor(public readonly payload) {}
}

export class GET_SEARCH_AGENTS_LIST {
  public static readonly type = `[${PREFIX}] GET SEARCH AGENTS LIST`;
  constructor(public readonly payload) {}
}
